import script from "./SpeV2PendingDismiss.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2PendingDismiss.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2PendingDismiss.vue?vue&type=style&index=0&id=c810daf4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c810daf4"]])

export default __exports__